
    import './styles.scoped.css';
    export default {
  "drag-overlay": "awsui_drag-overlay_1ksmw_1p072_9",
  "drag-overlay-item": "awsui_drag-overlay-item_1ksmw_1p072_13",
  "drag-overlay-container": "awsui_drag-overlay-container_1ksmw_1p072_38",
  "active": "awsui_active_1ksmw_1p072_64",
  "placeholder": "awsui_placeholder_1ksmw_1p072_74",
  "placeholder-item": "awsui_placeholder-item_1ksmw_1p072_83",
  "placeholder-container": "awsui_placeholder-container_1ksmw_1p072_89",
  "sorting": "awsui_sorting_1ksmw_1p072_96"
};
  